var exports = {
  "Ft": "CtaBanner__3YsEXo",
  "Yg": "CtaBanner__gridContent__prVN7T",
  "kG": "CtaBanner__content__1bQtlK",
  "zz": "CtaBanner__title__SbYwGI",
};

module.exports = exports;
